import { FC } from 'react';
import advertDetailCss from '../assets/advert-detail.module.scss';
import {
  Contacts,
  Description,
  Gallery,
  Header,
  ParameterList,
  PriceList,
  RemovalInformation,
  ServiceList,
} from '#advertDetail/components';

const Content: FC = () => (
  <div className={advertDetailCss.advertDetail}>
    <Gallery />
    <Header />
    <RemovalInformation />
    <PriceList />
    <Contacts />
    <ParameterList />
    <Description />
    <ServiceList />
  </div>
);

export { Content };
